import React, { useEffect, useState } from 'react';
import { Users, Ticket, ShoppingCart, Sparkles } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface UrgencyBannerProps {
  spots: number;
  onSale: () => void;
  viewers: number;
}
export function UrgencyBanner({
  spots,
  onSale,
  viewers
}: UrgencyBannerProps) {
  const [isSticky, setIsSticky] = useState(false);
  const [recentSale, setRecentSale] = useState({
    show: false,
    text: ''
  });
  useEffect(() => {
    const handleScroll = () => {
      const purchaseSection = document.getElementById('purchase');
      if (purchaseSection) {
        const rect = purchaseSection.getBoundingClientRect();
        setIsSticky(rect.top <= 100);
      }
    };
    window.addEventListener('scroll', handleScroll);
    const sales = ['1 cupón vendido hace 5 mins', 'Nuevo acceso desde Mendoza hace 2 min', '1 cupón reservado hace instantes', 'Sofía acaba de unirse a la comunidad', 'Acceso inmediato descargado hace 1 min'];
    let saleTimeout: NodeJS.Timeout;
    const triggerSale = () => {
      const randomTime = Math.floor(Math.random() * (25000 - 15000 + 1)) + 15000;
      saleTimeout = setTimeout(() => {
        setRecentSale({
          show: true,
          text: sales[Math.floor(Math.random() * sales.length)]
        });
        onSale();
        setTimeout(() => {
          setRecentSale({
            show: false,
            text: ''
          });
        }, 5000);
        triggerSale();
      }, randomTime);
    };
    triggerSale();
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(saleTimeout);
    };
  }, []);
  return <>
      {/* Floating Notification (When NOT sticky) */}
      <AnimatePresence data-id="element-309">
        {!isSticky && recentSale.show && <motion.div initial={{
        opacity: 0,
        x: -20,
        y: 20,
        scale: 0.9
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.9,
        transition: {
          duration: 0.2
        }
      }} className="fixed bottom-8 left-6 z-[60] bg-white p-2 rounded-2xl shadow-2xl shadow-pink-200/50 border border-[#FDF2F2] flex items-center gap-4 max-w-[300px] overflow-hidden" data-id="element-310">
            <div className="w-10 h-10 bg-[#FCE4EC] rounded-xl flex items-center justify-center text-[#C2185B] shrink-0 shadow-sm" data-id="element-311">
              <ShoppingCart size={18} data-id="element-312" />
            </div>
            <div className="pr-4" data-id="element-313">
              <p className="text-[10px] font-black text-[#C2185B] uppercase tracking-widest leading-none mb-1 opacity-80" data-id="element-314">
                Venta Reciente
              </p>
              <p className="font-bold text-[#2D2D2D] text-xs leading-tight tracking-tight" data-id="element-315">
                {recentSale.text}
              </p>
            </div>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} className="absolute top-1 right-2 text-[#D4AF37]" data-id="element-316">
              <Sparkles size={10} data-id="element-317" />
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Sticky Banner */}
      <motion.div initial={false} animate={{
      y: isSticky ? 0 : -100,
      opacity: isSticky ? 1 : 0
    }} className="py-3 fixed top-0 left-0 w-full z-50 px-4" data-id="element-318">
        <div className="max-w-4xl mx-auto" data-id="element-319">
          
        </div>
      </motion.div>
    </>;
}